var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2):_c('span',[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }